module.exports = __webpack_public_path__ + "img/right-arrow.d41d8cd9.svg";